import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({
  title = "Caspers Træservice",
  description = "Professionel og sikker træfældning af alle typer træer – fra simple opgaver til risikofyldte fældninger tæt på bygninger. Erfaring og uddannelse sikrer en veludført opgave.",
  ogImage = "https://assets.auxodev.dk/assets/e431b544-04c3-4ed0-906f-0354609bd752/p-20230223-091955.jpeg",
  canonicalUrl,
}) {
  // Ensure "Caspers Træservice" is in the title
  const formattedTitle = title.includes("Caspers Træservice")
    ? title
    : `${title} - Caspers Træservice`;

  return (
    <Helmet>
      <html lang="da" />
      <title>{formattedTitle}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={formattedTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={formattedTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}
